// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-photo[data-v-0b28bbc6]{width:2rem;height:2rem;margin:-.375rem 0}", ""]);
// Exports
module.exports = exports;
